import script from "./ImageUploaderDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUploaderDialog.vue?vue&type=script&setup=true&lang=js"

import "./ImageUploaderDialog.vue?vue&type=style&index=0&id=5b0ad647&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0ad647"]])

export default __exports__